import styled from 'styled-components'

import { ClinTheme } from '../../../../ClinTheme'

export const StyledSummaryContainer = styled.div({
  background: ClinTheme.colors.white,
  border: `2px solid ${ClinTheme.colors.black}`,
  padding: ClinTheme.space[5]
})
